import { render, staticRenderFns } from "./RequiredFieldText.vue?vue&type=template&id=44fcf67b&scoped=true&"
import script from "./RequiredFieldText.vue?vue&type=script&lang=js&"
export * from "./RequiredFieldText.vue?vue&type=script&lang=js&"
import style0 from "./RequiredFieldText.vue?vue&type=style&index=0&id=44fcf67b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcf67b",
  null
  
)

export default component.exports